import React from 'react'

const Background = () => {
  return (
    <div className="npay-background">
      <h4>Background</h4>
      <p>
        The FIRS is the government agency responsible for coordinating and collecting all revenue meant to flow into the government through taxes, custom duties and many more. For years the body has been setting standards on how citizens can effectively pay their taxes to the right channel while narrowing down the possibility of corruption, tax evasion and underpayment of required amounts.
        N-PAY is a fintech platform that serves as the adoption of technology into the service of the organization. The app will also enable the payment of other bills meant for services provided by the govenment
      </p>
    </div>
  )
}

export default Background